var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVolumeLow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.58078 4.43141C10.0599 3.9832 10.4523 4.13528 10.4523 4.76929V19.2305C10.4523 19.8647 10.0599 20.0168 9.58078 19.5684L5.07457 15.3535H2.08696V8.64685H5.07457L9.58078 4.43141ZM12.3386 16.0001C12.1093 16.0001 11.8796 15.9185 11.7043 15.7546C11.3541 15.427 11.3541 14.896 11.7043 14.569C13.2184 13.1527 13.2184 10.8484 11.7043 9.43217C11.3541 9.10463 11.3541 8.57368 11.7043 8.24653C12.0544 7.91937 12.622 7.91937 12.9718 8.24653C15.1846 10.3171 15.1846 13.6852 12.9718 15.7553C12.7969 15.9178 12.568 16.0001 12.3386 16.0001Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeLow);
export default __webpack_public_path__ + "static/media/volume-low.f04eff4ddcc6e9d4dceffe96f840c58c.svg";
export { ForwardRef as ReactComponent };